import {
  Directive,
  ElementRef,
  Input,
  OnDestroy,
  Renderer2,
} from '@angular/core'

import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { I18nService } from '@containers/i18n/i18n.service'
import { select, Store } from '@ngrx/store'
import { TranslateService } from '@ngx-translate/core'
import { fromEvent, Subscription } from 'rxjs'
import { isContentEditableEnabled as isContentEditableEnabledSelector } from '../../store/i18n.selector'
import { TranslationEditableModalComponent } from '../translation-editable-modal/translation-editable-modal.component'

@Directive({
  selector: '[translationEditableModalDirective]',
})
export class TranslationEditableModalDirective implements OnDestroy {
  private _translationKeys: Array<any>
  private _icon: HTMLImageElement
  private _translationDefaults: Array<any>

  @Input()
  public translationEditableModalShowIcon: boolean

  @Input()
  set translationEditableModalDirectiveDefaults(data: any) {
    this._translationDefaults = data
  }

  @Input()
  set translationEditableModalDirective(data: Array<any> | string) {
    const keys: Array<string> = []
    if (Array.isArray(data)) {
      data.forEach((item) => {
        if (Array.isArray(item)) {
          item.forEach((_i) => keys.push(_i.title))
        } else if (typeof item === 'object') {
          keys.push(item.title)
        } else {
          keys.push(item)
        }
      })
    } else {
      keys.push(data)
    }
    this._translationKeys = keys
  }
  private _isEnabled: boolean
  private _inProgress = false
  private _subscriptions: Array<Subscription> = []

  constructor(
    private elRef: ElementRef,
    private renderer2: Renderer2,
    private store: Store<any>,
    private i18nService: I18nService,
    private translateService: TranslateService,
    private matDialog: MatDialog,
  ) {
    this.handleContentEditableToggle()
    this.handleHostClick()
    this.initIcon()
  }

  ngOnDestroy(): void {
    this._subscriptions.forEach((subscription) => {
      subscription.unsubscribe()
    })
  }

  private initIcon() {
    this._icon = this.renderer2.createElement('img')
    this.renderer2.addClass(this._icon, 'edit-icon')
    this.renderer2.setAttribute(this._icon, 'src', '/assets/editable.svg')
  }

  private handleHostClick() {
    const sub = fromEvent(this.nativeElement, 'click', {
      capture: true,
    }).subscribe((e: Event) => {
      if (this._isEnabled) {
        e.preventDefault()
        e.stopImmediatePropagation()

        const config: MatDialogConfig = {
          data: {
            translationKeys: this._translationKeys,
            translationDefaults: this._translationDefaults,
          },
        }
        this.matDialog.open(TranslationEditableModalComponent, config)
      }
    })

    this.registrateSubscription(sub)
  }

  private handleIcon(isEnabled) {
    if (isEnabled) {
      this.renderer2.appendChild(this.nativeElement, this._icon)
    } else {
      this.renderer2.removeChild(this.nativeElement, this._icon)
    }
  }

  private handleContentEditableToggle() {
    const sub = this.store
      .pipe(select(isContentEditableEnabledSelector))
      .subscribe((isEnabled) => {
        this._isEnabled = isEnabled

        if (this.translationEditableModalShowIcon) {
          this.handleIcon(isEnabled)
        }
      })

    this.registrateSubscription(sub)
  }

  private registrateSubscription(sub) {
    this._subscriptions.push(sub)
  }

  private get nativeElement(): HTMLElement {
    return this.elRef.nativeElement
  }
}
